export default "__VITE_ASSET__ef829a9b__"